<template>
    <button :type="$attrs.type || 'button'" class="c-btn c-btn--primary" :disabled="loading || disabled">
        <template v-if="loading">...</template> 
        <template v-else>
            <slot></slot>
        </template>        
    </button>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>